import { Modal, addToast } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';

import {
  AxiosResult,
  AxiosResultDefaultError,
} from '../../../../../api/request';
import { useLayoutState } from '../../../../../hooks/useLayoutState';
import { Discount } from '../../api/discount';
import { DiscountForm } from './DiscountForm';

interface DiscountFormProps {
  show: boolean;
  recordToEdit: Discount | null;
  toggleModal: () => void;
  reloadDiscountList: () => void;
}

export const DiscountModal = ({
  recordToEdit,
  show,
  toggleModal,
  reloadDiscountList,
}: DiscountFormProps) => {
  const editing = !!recordToEdit;

  const prefix = 'tariffAndTuition.discounts';
  const { t } = useTranslation();
  const { showErrorModal } = useLayoutState();

  const onSubmit = async (
    result: AxiosResult<Discount, AxiosResultDefaultError>,
  ) => {
    const { error, data } = result;
    if (error && error.code === 'CONNECTION') {
      showErrorModal();
    } else if (error) {
      addToast({
        icon: 'error',
        color: 'danger',
        text: t('common.errors.save'),
      });
    }
    if (data) {
      reloadDiscountList();
      toggleModal();
      addToast({
        icon: 'success',
        color: 'success',
        text: editing ? t(`${prefix}.editChanges`) : t(`${prefix}.saveChanges`),
      });
    }
  };

  return (
    <Modal isOpen={show} toggle={toggleModal} size="lg" unmountOnClose>
      <DiscountForm
        recordToEdit={recordToEdit}
        onSubmit={onSubmit}
        onCancel={toggleModal}
      />
    </Modal>
  );
};
